<template>
  <div>
    <div class="nav_bar_red contentWidth_Parent" :class="headerClass">
      <div class="nav_bar p-0 h-32 contentWidth_Child m-l-5 m-r-5 navbar-item-container" style="display: -webkit-box; ">

        <div class="header-logo-wrapper" v-if="!togglesidebar">
          <div class="toggle-sidebar" @click="toggle_sidebar">
            <feather class="status_toggle middle sidebar-toggle" type="sidebar" id="sidebar-toggle">
            </feather>
          </div>
        </div>
        <!-- Mobile Hamburger Button -->
        <div class="mobile-hamburger-wrapper" @click="toggle_sidebar">
          <feather class="mobile-hamburger-icon" type="menu" id="mobile-sidebar-toggle">
          </feather>
        </div>
        <div class="buyer-supplier" >
          <a  v-show="false" :href="'https://www.chinaplasonline.com/eMarketplace/idx/' + currentLang" class="pr-3"
            t_label="emp2_Supplier_header_burger_Buyer">{{ $t("lbl_Buyer") }}</a>
          <span v-show="false">|</span>
          <a  v-show="false" :href="'https://www.chinaplasonline.com/eMarketplace/Supplier/' + currentLang"
            class="pl-3 font-weight-bold text-decoration-underline" t_label="emp2_Supplier_header_burger_Suppliers">{{
              $t("lbl_emp2_Suppliers") }}</a>
        </div>
        <div class="d-flex align-items-end">
          <Language class="dark" />
          <empProfile></empProfile>
          <div class="nav-right col-4 pull-right right-header p-0">
            <div class="d-flex align-items-center"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentWidth_Parent pb-2" style="display: none;">
      <div class="contentWidth_Child">
        <div class="row ml-0 mr-0">
          <a class="col-3 p-0 text-left d-none d-md-none d-lg-block" t_label="empbe_header_Logo"
            :href="'https://www.chinaplasonline.com/eMarketplace/idx/' + currentLang">
            <img :src="LogoPath()" class="img-fluid" style="padding: 10px 0px; width: 200px"
              alt="CPS+ 在線供需對接平台 | B2B sourcing platform | E-Market Place | EMP | 塑橡供應商配對平台" />
          </a>
          <div class="h1 text-danger text-center align-self-center flex-fill UAT">
            {{EnvTitle}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { empLayoutService } from "../../../src/_services";
import empProfile from "./empProfile";
import Language from "./language";
export default {
  components: {
    empProfile,
    Language,
  },
  data() {
    return {
      headerHtml: "",
     
    };
  },
  mounted() {
    // empLayoutService.GetEMPHeader().then(res => {
    //     this.headerHtml = res.data.replace("btn", "empbtn");
    // })
  },
  computed: {
    currentLang() {
      return localStorage.getItem("currentLang");
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    togglesidebar() {
      return this.$store.state.menu.togglesidebar;
    },
    headerClass(){

      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return "bg-primary";
      }
      else if (envName.toLowerCase() == 'ai') {
        return "ai-bg-primary";
      }
      return "";
    },

    isUatEnv() {
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return true;
      }

      return false;
    },
    EnvTitle(){
      var envName = process.env.VUE_APP_EMP_ENV_NAME;

      if (envName.toLowerCase() == 'uat') {
        return "UAT Environment";
      }
      if (envName.toLowerCase() == 'ai') {
        return "CPS+AI Environment";
      }
      return "";
    },   
  },

  methods: {
    LogoPath() {
      const locale =
        this.langid == "936" ? "sc" : this.langid == "950" ? "tc" : "en";
      const logoEndPoint = `/EMP_logos_${locale}.png?x-oss-process=image/format,webp`;

      return "https://cdn.adsalecdn.com/EMP/2-0/images" + logoEndPoint;
    },
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
    },
  },
};
</script>

<style>
/* Mobile Hamburger Button - Show on mobile/tablet (up to 991px) */
@media screen and (max-width: 991px){
  .mobile-hamburger-wrapper{
    display: flex !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 10px;
    position: absolute;
    left: 10px;
    z-index: 100;
    height: 32px;
  }
  .mobile-hamburger-icon{
    width: 20px;
    height: 20px;
    stroke: white;
    stroke-width: 2;
  }
  .header-logo-wrapper{
    display: none;
  }
}
@media screen and (min-width: 992px){
  .mobile-hamburger-wrapper{
    display: none;
  }
  .header-logo-wrapper{
    display: none;
  }
}
@media screen and (max-width:480px){
  .buyer-supplier{
    display: none;
  }
  .navbar-item-container{
    display: flex!important;
    justify-content: center !important; 
  }
  .contentWidth_Parent.pb-2{
    background-color: rgb(248, 248, 248) ;
  }
  .UAT{
    display: none;
  }
}
@media  screen and (min-width:480px) {
  .contentWidth_Parent.pb-2{
    background-color:white ;
  }
} 
.nav_bar_red {
  background: #cb242b;
  color: white;
  height: 32px;
  line-height: 1.65;
  position: fixed;
  width: 100%;
  z-index: 99;
  top: 0px;
}

.nav_bar_red .nav-menus {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.contentWidth_Parent {
  text-align: center;
  text-align: -webkit-center;
  text-align: -moz-center;
}

.nav_bar {
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
  align-items: center;
  position: relative;
}

.contentWidth_Child,
.container {
  max-width: 1265px;
  text-align: start;
  padding-left: 5px;
  padding-right: 5px;
}

.contentWidth_Parent.pb-2 {
  top: 32px;
  position: fixed;
  width: 100%;
  z-index: 9;
  
}

.nav_bar a:hover {
  color: #fff;
}

.nav_bar a {
  color: #fff;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.nav_bar_red .nav_bar_signin {
  margin: -6px 0px -7px 0px;
  padding: 6px 10px;
  background-color: black;
}

.f-black a {
  color: #000;
}

.f-black a:hover {
  color: #000;
}

.page-wrapper.compact-sidebar .page-body-wrapper div.sidebar-wrapper {
  top: 34px !important;
}

.page-wrapper.compact-sidebar .page-body-wrapper .page-body {
  /* margin-top: 168px !important; */
  padding-top: 40px;
}

.ai-bg-primary
{
  background-color: var(--theme-ai) !important;
}
</style>
